/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ForgotPasswordInput } from '../../models/forgot-password-input';
import { ForgotPasswordResponse } from '../../models/forgot-password-response';

export interface ApiIdentityAccountForgotpasswordPost$Params {
      body?: ForgotPasswordInput
}

export function apiIdentityAccountForgotpasswordPost(http: HttpClient, rootUrl: string, params?: ApiIdentityAccountForgotpasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ForgotPasswordResponse>> {
  const rb = new RequestBuilder(rootUrl, apiIdentityAccountForgotpasswordPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ForgotPasswordResponse>;
    })
  );
}

apiIdentityAccountForgotpasswordPost.PATH = '/api/identity/account/forgotpassword';
